import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, Button, Table } from "reactstrap";
import { Download } from "react-feather";
import { toast } from "react-toastify";
import { getInvoiceService } from "./services/report-service";
import moment from "moment";
import { getFileUrl } from "../../getFileUrl";
import { useLoader } from "../../_helper/LoaderContext";
// import { dummyReports } from "./data/data";

const formatDate = (date) => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  return formatter.format(new Date(date));
};

const ViewReport = () => {
  const { id } = useParams();
  const { setLoading } = useLoader();
  const [report, setReport] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [reportUrl, setReportUrl] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getInvoiceService(id);
      const document = res?.data?.data?.documents;
      // const document = dummyReports.find(report => report._id === id);
      if (document) {
        setReport(document);
        const reportPath = document.event_data?.report;
        const reportUrl = await getFileUrl(reportPath);
        setReportUrl(reportUrl);
      } else {
        // toast.warning("Report not found");
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      // toast.warning("Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  if (!report || !reportUrl) {
    return (
      <Card className="px-3 mt-4">
        <CardBody>Loading report...</CardBody>
      </Card>
    );
  }

  const patientName = report.patient?.name || "N/A";
   const testTitle =
    report.event_data?.content?.test_detail?.lab_report_title || "N/A";
  const testDate =
    report.event_data?.content?.test_detail?.date_of_examination ||
    report.createdAt;

  // const getFileType = (url) => {
  //   const extension = url.split(".").pop().toLowerCase();
  //   if (extension === "pdf") return "pdf";
  //   if (["jpg", "jpeg", "png", "gif"].includes(extension)) return "image";
  //   return "unknown";
  // };

  const getFileType = (url) => {
    try {
      // Parse the URL to get the pathname
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      
      // Extract the extension from the pathname
      const extension = pathname.split(".").pop().toLowerCase();
      
      if (extension === "pdf") return "pdf";
      if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension)) return "image";
      return "unknown";
    } catch (error) {
      console.error("Error parsing URL:", error);
      // Fallback to the old method
      const extension = url.split(".").pop().toLowerCase().split("?")[0];
      if (extension === "pdf") return "pdf";
      if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension)) return "image";
      return "unknown";
    }
  };

  const fileType = getFileType(reportUrl);

  const handleDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      const response = await fetch(reportUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      const extension = reportUrl.split(".").pop().toLowerCase();
      const filename = `${patientName.replace(/\s+/g, "_")}_${testTitle.replace(
        /\s+/g,
        "_"
      )}_Report.${extension}`;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success("Report downloaded successfully!");
    } catch (error) {
      console.error("Download failed:", error);
      // toast.warning("Download failed. Opening in new tab.");
      const link = document.createElement("a");
      link.href = reportUrl;
      link.download = `${patientName.replace(/\s+/g, "_")}_${testTitle.replace(
        /\s+/g,
        "_"
      )}_Report`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } finally {
      setTimeout(() => {
        setIsDownloading(false);
      }, 2000);
    }
  };

  // const calculateAge = (birthDate) => {
  //   const birthDateMoment = moment(birthDate); // Parse the birth date
  //   const currentDate = moment(); // Get the current date
  //   // Calculate the difference in years
  //   const age = currentDate.diff(birthDateMoment, "years");
  //   return age;
  // };

  return (
    <Card className="px-3 mt-4">
      <CardBody>
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <CardTitle tag="h5">Report Details</CardTitle>
          <div className="text-muted">{formatDate(testDate)}</div>
        </div>
        <Table bordered className="my-3">
          <tbody>
            <tr>
              <th>
                <strong>Patient Name</strong>
              </th>
              <td>{patientName}</td>
              <th>
                <strong>NAKBHO Health ID</strong>
              </th>
              <td>
                {report.patient?.health_id?.match(/.{1,4}/g).join(" ") || "N/A"}
              </td>
            </tr>
            <tr>
              <th>
                <strong>Gender</strong>
              </th>
              <td>
                {report.patient?.gender
                  ? report.patient.gender.charAt(0).toUpperCase() +
                    report.patient.gender.slice(1)
                  : "N/A"}
              </td>
              <th>
                <strong>Age</strong>
              </th>
              <td>
                {/* {`${calculateAge(report.patient?.dob)} Years` ||
                  report.patient?.age ||
                  "N/A"} */}
                  {report.patient?.age || "N/A"}
              </td>
            </tr>
            <tr>
              <th>
                <strong>Test</strong>
              </th>
              <td colSpan="3">{testTitle}</td>
            </tr>
          </tbody>
        </Table>

        <div className="d-flex justify-content-between align-items-center">
          <strong>Report:</strong>
          <Button
            color="outline-primary hover:[background:linear-gradient(180.05deg,#006E27_20.14%,#033415_87.13%)]"
            onClick={handleDownload}
            disabled={isDownloading}
          >
            <Download size={16} className="me-2" />
            {isDownloading ? "Downloading..." : "Download Report"}
          </Button>
        </div>
        <div className="mt-2">
          {fileType === "pdf" ? (
            <iframe
              src={reportUrl}
              // src={'http://localhost:3000/report.pdf'}
              title="PDF Report"
              width="100%"
              height="500px"
            />
          ) : fileType === "image" ? (
            <img
              src={reportUrl}
              alt="Report"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          ) : (
            <iframe
              src={reportUrl}
              title="Report"
              width="100%"
              height="500px"
            />
          )}
        </div>
        {/* {report.event_data?.content?.note && (
          <CardText>
            <strong>Note:</strong>&nbsp;{report.event_data.content.note}
          </CardText>
        )} */}
      </CardBody>
    </Card>
  );
};

export default ViewReport;
